export const ROLES = {
  RECORDING: "webrtc-viewer",
  ATTENDE: "attendee",
  SPEAKER: "speaker",
};
